import { Pipe, PipeTransform } from '@angular/core';
import groupBy from 'lodash.groupby';
import { NOT_DEFINED_DELIVERY_CARRIER_ID } from '~app/modules/account/modules/orders-history/constants';

import { DeliveryTracking, DeliveryView } from '../models';

@Pipe({
  name: 'productDelivery'
})
export class ProductDeliveryPipe implements PipeTransform {

  transform(trackings: DeliveryTracking[]): DeliveryView[] {
    const groupedData = this.groupByDeliveryData(trackings);

    return Object.entries(groupedData).map(([origin, originData]) => {
      return {
        origin,
        carriers: Object.entries(originData).map(([carrier, carrierData]) => {
          return {
            carrier,
            trackings: Object.entries(carrierData).map(([tracking, trackingData]) => {
              const [{ trackingNumber, trackingUrl }] = trackingData as DeliveryTracking[];

              return { trackingNumber, trackingUrl };
            }),
          };
        }),
      };
    });
  }

  private transformTrackingForGroupBy(tracking: DeliveryTracking) {
    let carrier: string;
    if ((tracking.carrier === null) && tracking.customCarrier) {
      carrier = tracking.customCarrier;
    } else if (tracking.carrier !== null) {
      carrier = tracking.carrier.name;
    } else {
      carrier = NOT_DEFINED_DELIVERY_CARRIER_ID;
    }

    return {
      ...tracking,
      carrier,
      origin: tracking.origin.name,
    };
  }

  private groupByDeliveryData(trackings: DeliveryTracking[]) {
    const mappedTrackings = trackings.map(this.transformTrackingForGroupBy);
    const grouppedByCountry = groupBy(mappedTrackings, 'origin');

    return Object.entries(grouppedByCountry).reduce((acc, [origin, list]) => {
      const groupByCarrier = groupBy(list, 'carrier');
      const groupByTrackingNumber = Object.entries(groupByCarrier)
        .reduce((carrierAcc, [carrierName, carrierList]) => {
          return {
            ...carrierAcc,
            [carrierName]: groupBy(carrierList, 'trackingNumber'),
          };
        }, {});

      return {
        ...acc,
        [origin]: groupByTrackingNumber,
      };
    }, {});
  }

}
